import React from 'react';
import { useDispatch } from 'react-redux';

import GeneralPageMessage from 'components/Shared/GeneralPageMessage/GeneralPageMessage';
import { signIn, authActions } from 'store/auth/slice';

const IdentityErrorMessage: React.FC = () => {
  const dispatch = useDispatch<any>();

  const messageValues = {
    link1: (chunks: string) => (
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          dispatch(authActions.setFrictionlessIdentityError({ showError: false }));
          dispatch(signIn());
        }}
        style={{ color: '#2B77CC', textDecoration: 'underline', cursor: 'pointer' }}
      >
        {chunks}
      </a>
    ),
  };

  return (
    <GeneralPageMessage
      header="IDENTITY_ERROR_HEADER"
      text="IDENTITY_ERROR_TEXT"
      messageValues={messageValues}
    />
  );
};

export default IdentityErrorMessage;
